import { render, staticRenderFns } from "./ModalPlanUpdate.vue?vue&type=template&id=434e3f30"
import script from "./ModalPlanUpdate.vue?vue&type=script&lang=ts"
export * from "./ModalPlanUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports